module.exports = __webpack_public_path__ + "assets/169f85d59cd586dad9ae947efd6061ac.png";